import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

import { loadingExceptionRoutes } from '../constants/router';
import { LoadingService } from '../services/loading/loading.service';
import { SKIP_LOADER } from './loader-context';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  const skip =
    req.context.get(SKIP_LOADER) || loadingExceptionRoutes.some(route => req.url.includes(route));

  if (skip) {
    return next(req);
  }

  loadingService.showLoader();
  return next(req).pipe(finalize(() => loadingService.hideLoader()));
};
